import { useMemo } from 'react';
import { useI18n } from '../i18n';
import { useAssetOwnerBookings } from '../hooks/useAssetOwnerBookings';
import type { AppLanguage } from '../i18n/types';
import { resolveBookingConfirmationVenue } from '../utils/bookingConfirmationWindow';
import { AssetOwnerBookingCalendar } from './AssetOwnerBookingCalendar';

export type AssetOwnerSchedulePanelProps = {
  assetId: string;
  assetRecord?: Record<string, unknown> | null;
  language: AppLanguage;
  theme?: 'dark' | 'light';
};

/** Owner-only booking calendar for a single asset. */
export function AssetOwnerSchedulePanel({
  assetId,
  assetRecord = null,
  language,
  theme = 'dark',
}: AssetOwnerSchedulePanelProps) {
  const { t } = useI18n();
  const { bookings, loading, error, refetch } = useAssetOwnerBookings(assetId, true);
  const venue = useMemo(
    () => resolveBookingConfirmationVenue(assetId, [assetRecord], language),
    [assetId, assetRecord, language],
  );

  return (
    <AssetOwnerBookingCalendar
      bookings={bookings}
      assetRecord={assetRecord}
      assetName={venue.assetName}
      assetAddress={venue.assetAddress}
      loading={loading}
      error={error}
      language={language}
      theme={theme}
      t={t}
      onRetry={refetch}
    />
  );
}
